import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Tumi/TumiLogo.png'


const _withScopeId = n => (_pushScopeId("data-v-27dcad83"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "TumiBackLogin" }
const _hoisted_2 = {
  key: 0,
  class: "TumiLogin"
}
const _hoisted_3 = { class: "TumiForm" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "LogoTumi",
  class: "mb-3"
}, null, -1))
const _hoisted_5 = { class: "d-grid gap-2 mb-2 mb-3" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Password lost?")
const _hoisted_7 = { class: "TumiErrorLogin mt-3" }
const _hoisted_8 = {
  key: 0,
  class: "TumiTextWarning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.Auth)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mail) = $event)),
              placeholder: "Email"
            }, null, 512), [
              [_vModelText, _ctx.mail]
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "password",
              class: "form-control",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pass) = $event)),
              placeholder: "Password"
            }, null, 512), [
              [_vModelText, _ctx.pass]
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.Login && _ctx.Login(...args))),
                class: "btn btn-primary"
              }, "Log in")
            ]),
            _createVNode(_component_router_link, { to: {path:'/RetrievePass'} }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(_ctx.error), 1))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}